import { useEffect, useState } from "react";
import { SvgChevronRight, SvgWindowFullScreen, SvgWindowSplitVertical } from "@itwin/itwinui-icons-react";
import { Header, IconButton, Tooltip } from "@itwin/itwinui-react";
import { IModelSelector } from "./ImodelSelector";
import styles from "./VisualizerHeader.module.css";
import { useAppSelector } from "store";

interface VisualizerHeaderProps {
  onCollapse: () => void;
  onExpand: () => void;
  onReset: () => void;
  expanded: boolean;
}

export const VisualizerHeader = ({ onExpand, onCollapse, onReset, expanded: fullScreen }: VisualizerHeaderProps) => {
  const [expanded, setExpanded] = useState(fullScreen);
  const layout = useAppSelector((state) => state.settings.layout);

  const onExpandClick = () => {
    setExpanded(true);
    onExpand();
  }

  const onResetClick = () => {
    setExpanded(false);
    onReset();
  }

  useEffect(() => setExpanded(fullScreen), [fullScreen]);

  const expandBtn = (<Tooltip key="full-screen-btn" content={"Full screen display"} placement="bottom" delay={500} >
    <IconButton styleType="borderless" onClick={onExpandClick} className={expanded ? styles.hidden : ""} data-testid="atp-fullscreen-btn"><SvgWindowFullScreen /></IconButton>
  </Tooltip>);

  const hideBtn = (<Tooltip key="collapse-btn" content={"Hide preview panel"} placement="bottom" delay={500}>
    <IconButton styleType="borderless" onClick={onCollapse} className={expanded ? styles.hidden : ""} data-testid="atp-hide-preview-btn"><SvgChevronRight /></IconButton>
  </Tooltip>);

  const resetBtn = (
    <Tooltip key="reset-btn" content={"Reset windows"} placement="bottom" delay={500}>
      <IconButton styleType="borderless" onClick={onResetClick} className={!expanded ? styles.hidden : ""}  data-testid="atp-reset-btn"><SvgWindowSplitVertical /></IconButton>
    </Tooltip>
  )

  let actions = [expandBtn, hideBtn, resetBtn];

  if (layout.editorPanel === "hidden")
    actions = [];

  return (
    <Header
      appLogo={null}
      isSlim={true}
      className={styles.hideLogoDivider}
      breadcrumbs={<IModelSelector />}
      actions={actions}
      data-testid="atp-preview-header"
    />
  )
}